/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Media Blog API
 * API сервиса статей (MVP).
 * OpenAPI spec version: 1.12.0
 */
import { fetcher } from '../../../utils/fetcher';
import type {
  EntityCreateRubricReq,
  EntityRubric,
  EntityUpdateRubricReq,
  ErrorhandlerErrorResponse,
  PostAdminV1Rubrics200,
  PutAdminV1RubricsId200,
} from '../../models';

/**
 * Create a new rubric with name
 * @summary Create a new rubric
 */
export type postAdminV1RubricsResponse200 = {
  data: PostAdminV1Rubrics200;
  status: 200;
};

export type postAdminV1RubricsResponse400 = {
  data: ErrorhandlerErrorResponse;
  status: 400;
};

export type postAdminV1RubricsResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type postAdminV1RubricsResponseComposite =
  | postAdminV1RubricsResponse200
  | postAdminV1RubricsResponse400
  | postAdminV1RubricsResponse500;

export type postAdminV1RubricsResponse = postAdminV1RubricsResponseComposite & {
  headers: Headers;
};

export const getPostAdminV1RubricsUrl = () => {
  return `/admin/v1/rubrics`;
};

export const postAdminV1Rubrics = async (
  entityCreateRubricReq: EntityCreateRubricReq,
  options?: RequestInit
): Promise<postAdminV1RubricsResponse> => {
  return fetcher<postAdminV1RubricsResponse>(getPostAdminV1RubricsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(entityCreateRubricReq),
  });
};

/**
 * Update the name of a rubric by ID
 * @summary Update rubric by ID
 */
export type putAdminV1RubricsIdResponse200 = {
  data: PutAdminV1RubricsId200;
  status: 200;
};

export type putAdminV1RubricsIdResponse400 = {
  data: ErrorhandlerErrorResponse;
  status: 400;
};

export type putAdminV1RubricsIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type putAdminV1RubricsIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type putAdminV1RubricsIdResponseComposite =
  | putAdminV1RubricsIdResponse200
  | putAdminV1RubricsIdResponse400
  | putAdminV1RubricsIdResponse404
  | putAdminV1RubricsIdResponse500;

export type putAdminV1RubricsIdResponse =
  putAdminV1RubricsIdResponseComposite & {
    headers: Headers;
  };

export const getPutAdminV1RubricsIdUrl = (id: string) => {
  return `/admin/v1/rubrics/${id}`;
};

export const putAdminV1RubricsId = async (
  id: string,
  entityUpdateRubricReq: EntityUpdateRubricReq,
  options?: RequestInit
): Promise<putAdminV1RubricsIdResponse> => {
  return fetcher<putAdminV1RubricsIdResponse>(getPutAdminV1RubricsIdUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(entityUpdateRubricReq),
  });
};

/**
 * Delete a rubric by its ID
 * @summary Delete rubric by ID
 */
export type deleteAdminV1RubricsIdResponse204 = {
  data: null;
  status: 204;
};

export type deleteAdminV1RubricsIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type deleteAdminV1RubricsIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type deleteAdminV1RubricsIdResponseComposite =
  | deleteAdminV1RubricsIdResponse204
  | deleteAdminV1RubricsIdResponse404
  | deleteAdminV1RubricsIdResponse500;

export type deleteAdminV1RubricsIdResponse =
  deleteAdminV1RubricsIdResponseComposite & {
    headers: Headers;
  };

export const getDeleteAdminV1RubricsIdUrl = (id: string) => {
  return `/admin/v1/rubrics/${id}`;
};

export const deleteAdminV1RubricsId = async (
  id: string,
  options?: RequestInit
): Promise<deleteAdminV1RubricsIdResponse> => {
  return fetcher<deleteAdminV1RubricsIdResponse>(
    getDeleteAdminV1RubricsIdUrl(id),
    {
      ...options,
      method: 'DELETE',
    }
  );
};

/**
 * Retrieve the list of all rubrics
 * @summary Get all rubrics
 */
export type getV1RubricsResponse200 = {
  data: EntityRubric[];
  status: 200;
};

export type getV1RubricsResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type getV1RubricsResponseComposite =
  | getV1RubricsResponse200
  | getV1RubricsResponse500;

export type getV1RubricsResponse = getV1RubricsResponseComposite & {
  headers: Headers;
};

export const getGetV1RubricsUrl = () => {
  return `/v1/rubrics`;
};

export const getV1Rubrics = async (
  options?: RequestInit
): Promise<getV1RubricsResponse> => {
  return fetcher<getV1RubricsResponse>(getGetV1RubricsUrl(), {
    ...options,
    method: 'GET',
  });
};

/**
 * Retrieve rubric information either by UUID or slug
 * @summary Get rubric by ID or slug
 */
export type getV1RubricsIdResponse200 = {
  data: EntityRubric;
  status: 200;
};

export type getV1RubricsIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type getV1RubricsIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type getV1RubricsIdResponseComposite =
  | getV1RubricsIdResponse200
  | getV1RubricsIdResponse404
  | getV1RubricsIdResponse500;

export type getV1RubricsIdResponse = getV1RubricsIdResponseComposite & {
  headers: Headers;
};

export const getGetV1RubricsIdUrl = (id: string) => {
  return `/v1/rubrics/${id}`;
};

export const getV1RubricsId = async (
  id: string,
  options?: RequestInit
): Promise<getV1RubricsIdResponse> => {
  return fetcher<getV1RubricsIdResponse>(getGetV1RubricsIdUrl(id), {
    ...options,
    method: 'GET',
  });
};
